import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer({
    key: 'onfish',
    storage,
    whiteList: ['auth', 'user', 'person'],
  }, reducers);

  return persistedReducer;
}